import HttpClient from "@/services/HttpClient";
import StoreService from "@/store";
import { EServices } from "@/types";
import { inject, injectable } from "tsyringe";
import { ESchemes } from "../types";

@injectable()
export default class CryptoMicroservicesClient {
  constructor(@inject(EServices.http) private http: HttpClient) {}

  async getWalletAddress(
    currencySymbol: string,
    chain: string,
    scheme: ESchemes = ESchemes.default
  ): Promise<string> {
    const response = await this.http.get(
      `/v1/crypto/${chain}/${currencySymbol.toLowerCase()}/${scheme}/addresses`
    );
    return response.data.address;
  }

  // async getDollarRatePerCrypto(
  //   currencySymbol: string,
  //   chain: string,
  //   scheme: ESchemes = ESchemes.default
  // ): Promise<number> {
  //   const response = await this.http.get(
  //     `/v1/crypto/${chain}/${currencySymbol.toLowerCase()}/${scheme}/transactions/rate`
  //   );
  //   return response.data.price;
  // }
  async getDollarRatePerCrypto(
    currencySymbol: string,
    chain: string,
    scheme: ESchemes = ESchemes.default
  ): Promise<number> {
    return 90000;
  }
}
